import React from 'react';
import Chart from 'react-apexcharts';
import { alignedBox } from './AlignedBox';
import { denormalizeFieldName } from './utils';
import { generateColors } from './colors';

export const groupDataForGroupedColumnChart = (data, xField, yField, pivotField) => {
  const totalsByCategory = {};
  const groupedData = {};

  data.forEach((row) => {
    const key = row[xField] || 'Unknown';
    const pivot = row[pivotField];
    const value = row[yField] || 0;

    if (!groupedData[pivot]) {
      groupedData[pivot] = {};
    }
    totalsByCategory[key] = (totalsByCategory[key] || 0) + value;
    groupedData[pivot][key] = (groupedData[pivot][key] || 0) + value;
  });

  return {
    groupedData,
    totalsByCategory,
  }
};

export const GroupedColumnChart = ({ title, data, xField, yField, pivotField }) => {
  const categories = [...new Set(data.map(row => row[xField]))];
  const pivotValues = [...new Set(data.map(row => row[pivotField]))];

  const { groupedData, totalsByCategory } = groupDataForGroupedColumnChart(data, xField, yField, pivotField);

  const categoriesWithValues = categories.reduce((acc, cat) => {
    if (!totalsByCategory[cat]) return acc;
    return [...acc, cat];
  }, []);
  categoriesWithValues.sort((a, b) => {
    if (a < b) return -1;
    return a > b ? 1 : 0
  });
  const series = pivotValues.map((pivot) => ({
    name: pivot,
    data: categoriesWithValues.map(cat => {
      const total = totalsByCategory[cat] || 1;
      const val = groupedData[pivot]?.[cat] || 0;
      return (val / total) * 100;
    }),
  }));

  const colors = generateColors(pivotValues.length);

  const options = {
    chart: {
      type: 'bar',
      stacked: true,
      stackType: '100%',
    },
    legend: {
      show: true,
      position: 'right',
      horizontalAlign: 'left',
      fontSize: '10px',
      markers: {
        width: 10,
        height: 10,
        radius: 50,
      },
      labels: {
        colors,
      },
    },
    colors,
    xaxis: {
      categories: categoriesWithValues,
      labels: {
        style: {
          fontSize: '10px',
        },
      },
      title: {
        text: `${denormalizeFieldName(xField)}`,
      },
    },
    yaxis: {
      max: 100,
      tickAmount: 2,
      labels: {
        style: {
          fontSize: '10px',
        },
        formatter: (val) => `${val.toFixed(1)}%`,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '60%',
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  return alignedBox(title, (
    <Chart options={options} series={series} type="bar" />
  ));
};
